import { AzurePersonRoles } from './AzurePersonRoles';
import { UserModel, RoleModel } from '../services/api-clients-generated.service';
import { DDBase } from './DDBase';

export class AzurePerson extends DDBase {
  id: number;
  image: string;
  phoneNumber: string;
  email: string;
  faxNumber: string;
  roles?: AzurePersonRoles[];

  static mapFromUserModel(userModel: UserModel) {
    const newItem = new AzurePerson();
    newItem.id = userModel.id;
    if (userModel.lastName && userModel.firstName) {
      newItem.name = userModel.lastName + ' ' + userModel.firstName;
    } else if (userModel.lastName) {
      newItem.name = userModel.lastName
    } else {
      newItem.name = userModel.email;
    }
    newItem.image = userModel.imageUrl;
    newItem.phoneNumber = userModel.phone;
    newItem.email = userModel.email;
    newItem.faxNumber = userModel.fax;
    newItem.roles = AzurePerson.mapFromRoleModels(userModel.roles);
    return newItem;
  }
  static mapFromUserModels(items: UserModel[]): AzurePerson[] {
    let result = items.map(item => AzurePerson.mapFromUserModel(item));
    for (let i = 0; i < items.length-1; i++) {
      const p0 = result[i];
      const p1 = result[i+1];
      if (p0.name == p1.name) {
        p0.name = p0.name + ' (' + p0.email + ')';
        if (i == items.length - 2 || (i < items.length-2 && p1.name != result[i+2].name)) {
          p1.name = p1.name + ' (' + p1.email + ')';
        }
      }
    }

    return result;
  }
  static mapFromRoleModels(roles: RoleModel[]): AzurePersonRoles[] {
    return roles.map(role => AzurePerson.mapFromRoleModel(role));
  }
  static mapFromRoleModel(role: RoleModel): AzurePersonRoles {
    return role.id;
  }

  isUserAdmin() {
    return this.hasUserRole(AzurePersonRoles.Administrator);
  }

  isUserAdvisor() {
    return this.hasUserRole(AzurePersonRoles.Advisor);
  }

  isUserApprovers() {
    return this.hasUserRole(AzurePersonRoles.Approvers);
  }

  isUserPurchasing() {
    return this.hasUserRole(AzurePersonRoles.Purchasing);
  }

  private hasUserRole(findRole: AzurePersonRoles): boolean {
    const found = this.roles.find(role => role === findRole);
    return found ? true : false;
  }
}

